module.exports = __webpack_public_path__ + "static/img/缺考说明.a0697196.jpg";